var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7099 60.2095C35.6261 54.8751 22.6116 44.9021 19.4273 42.0319C16.3112 39.2232 13.3303 32.0299 14.2617 24.3762",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0633 48.7158C57.8524 46.1646 54.7572 38.5814 60.0633 28.6582",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5664 17.8726C47.9097 17.6252 53.3194 15.3074 56.2122 8.01607",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0884 31.6626C37.7544 31.6626 30.6467 27.7423 28.5664 24.0001",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.342 45.5005C17.5188 45.8946 6.89801 44.4993 3.00083 35.7657",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5664 75.0001C43.9962 64.6939 39.3727 46.8374 40.8557 38.4834C42.3387 30.1293 47.3984 10.7513 40.8557 3.00012",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2874 65.8437C47.1433 60.7126 54.9971 49.9197 63.5649 47.7965C72.1326 45.6734 75.1671 32.0496 75.6133 25.5031",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8517 67.4415C66.138 72.6081 55.9547 75.576 45.075 75.576C33.889 75.576 23.4394 72.4387 14.5662 67.0001",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconW);
export default __webpack_public_path__ + "static/media/iconW.84132c28cab2ee92ec0d16944cb5b7e2.svg";
export { ForwardRef as ReactComponent };